module.exports = __webpack_public_path__ + "media/Sim.93942791.mp3";